<p-dialog
  [(visible)]="visible"
  (onHide)="close()"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{width: '90vw', maxWidth: '1400px'}"
  styleClass="request-result-modal">

  <ng-template pTemplate="header">
    <div class="modal-header-custom">
      <h2>{{ 'Request report' | translate }}</h2>
    </div>
  </ng-template>

  <div class="modal-content">
    @if (downloading()) {
      <div class="download-progress-container">
        @if (downloadProgress() < 100) {
          <div class="progress-info">
            <p>{{ 'Creation of report' | translate }}...</p>
            <app-download-progress
              [downloadProgress]="downloadProgress()"
            ></app-download-progress>
          </div>
        } @else {
          <app-loading [loading]="downloading()"></app-loading>
        }
      </div>
    } @else {
      <div class="content-layout">
        <!-- Dynamic Blocks from Template JSON (Non-Steps) -->
        <ng-container *ngFor="let block of getNonStepsBlocks()">
          @if (isAgrotechnicalMeasuresBlock(block)) {
            @if (hasAgrotechnicalMeasures()) {
              <div class="section">
                <h3 class="section-title">{{ getBlockTitle(block) }}</h3>
                <app-data-table
                  [columns]="agrotechnicalMeasuresColumns"
                  [data]="agrotechnicalMeasuresData"
                  [config]="getStepTableConfig()"
                  [totalRecords]="getAgrotechnicalMeasuresTotalRecords()">
                </app-data-table>
              </div>
            }
          } @else {
            <div class="section">
              <h3 class="section-title">{{ getBlockTitle(block) }}</h3>
              <app-data-table
                [columns]="getBlockTableColumns(block)"
                [data]="getBlockTableData(block)"
                [config]="getStepTableConfig()"
                [totalRecords]="1">
              </app-data-table>
            </div>
          }
        </ng-container>

        <div class="mt-3"></div>
        <!-- Steps Blocks -->
        <ng-container *ngFor="let stepsBlock of getStepsBlocks()">
          <div class="section data-rows-section">
            <ng-container *ngFor="let step of stepsBlock.steps">
              <div class="data-row">
                <div class="data-row-image" *ngIf="getStepPhotoControl(step) as photoControl">
                  <div class="images-grid">
                    @for (path of getStepImagePaths(photoControl); track path) {
                      <div class="image-container" (click)="openImageGallery(path)">
                        <img [src]="path" [alt]="getStepTitle(step)"/>
                        <div class="image-overlay">
                          <i class="pi pi-search-plus"></i>
                        </div>
                      </div>
                    }
                  </div>
                </div>

                <!-- Table on the right -->
                <div class="data-row-table">
                  <div class="image-description m-2">
                    {{ getStepTitle(step) }}
                  </div>
                  <app-data-table
                    [columns]="getStepTableColumns(step)"
                    [data]="getStepTableData(step)"
                    [config]="getStepTableConfig()"
                    [totalRecords]="1">
                  </app-data-table>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    }
  </div>

</p-dialog>
